import request from '@/utils/request'

const purchaseUrl = process.env.VUE_APP_PURCHASE_API

// 获取直接采购列表
export function getDirectPurchaseListApi(params) {
  return request({
    url: purchaseUrl + '/workbench/purchaser/page/purchase-direct-orders',
    method: 'get',
    params
  })
}

// 删除直接采购
export function deleteDirectPurchaseApi(orderId) {
  return request({
    url: purchaseUrl + `/workbench/purchaser/direct-orders/${orderId}`,
    method: 'delete'
  })
}

// 发布直接采购
export function publishDirectPurchaseApi(data, orderId) {
  if (orderId) {
    return request({
      url:
        purchaseUrl + `/workbench/purchaser/direct-orders/${orderId}/publish`,
      method: 'put',
      data: data
    })
  }
  return request({
    url: purchaseUrl + '/workbench/purchaser/direct-orders/publish',
    method: 'post',
    data: data
  })
}

// 保存直接采购
export function saveDirectPurchaseApi(data, orderId) {
  if (orderId) {
    return request({
      url: purchaseUrl + `/workbench/purchaser/direct-orders/${orderId}`,
      method: 'put',
      data: data
    })
  }
  return request({
    url: purchaseUrl + `/workbench/purchaser/direct-orders`,
    method: 'post',
    data: data
  })
}

// 查询直接采购详情
export function getDirectPurchaseDetailApi(orderId) {
  return request({
    url: purchaseUrl + `/workbench/purchaser/direct-orders/${orderId}/detail`,
    method: 'get'
  })
}
